// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"673":"c2319a5a409f828a36b6","827":"5d027131fb8056af12fb"}[chunkId] + ".js";
};